import { LogoutButton } from "../auth/LogoutButton.js";
import type { CreateableOrganisationType } from "../auth/isValidOrganisationType.js";
import { SignupSplitLayout } from "../auth/signup/SignupSplitLayout.js";
import { ONBOARDING_SELECTOR_BUTTON_SX } from "../features/organisations/onboarding/onboardingDesign.js";

interface Props {
  isAuthenticated: boolean;
  /**
   * Decides the copy of the brand panel: a project-contractee invitation
   * addresses a property owner, every other invitation a trade business.
   */
  signupRole?: CreateableOrganisationType;
  /** Widest the centred content grows; defaults to the signup page's width. */
  contentMaxWidth?: number;
}

/**
 * The shell of every invitation screen: the split layout of the signup page,
 * with a log-out action next to the language switch once signed in.
 */
export const InvitationPage = ({
  isAuthenticated,
  signupRole = "CRAFTSMAN",
  contentMaxWidth,
  children,
}: React.PropsWithChildren<Props>) => (
  <SignupSplitLayout
    signupRole={signupRole}
    alignTopOnPhone
    {...(contentMaxWidth !== undefined && { contentMaxWidth })}
    topBarAction={
      isAuthenticated ? (
        <LogoutButton
          color="inherit"
          fullWidth={false}
          sx={{
            ...ONBOARDING_SELECTOR_BUTTON_SX,
            border: 1,
            borderStyle: "solid",
            minWidth: 44,
          }}
        />
      ) : undefined
    }
  >
    {children}
  </SignupSplitLayout>
);
